import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const VerifyPasswordSchema = yup.object({
  /**
   * This is an input accepting the existing users password.
   * It is not a new password so no restrictions need to be set on the incoming string.
   */
  password: yup.string().required(REQUIRED_MESSAGE),
})

export type TVerifyPasswordSchema = yup.InferType<typeof VerifyPasswordSchema>
